import type { UserOption } from '@/components/pickers/userOption.ts';
import type { OutreachQueueKind } from '@/lib/outreachQueue.ts';

/** What the page itself narrows the queue by; the organisation is the header's. */
export interface OutreachFilterState {
  user: UserOption | null;
  skillId: string;
  kind: OutreachQueueKind | '';
  windowHours: number;
  includeExpired: boolean;
}

/** Nothing picked and the default window — also what Reset filters restores. */
export const EMPTY_OUTREACH_FILTERS: OutreachFilterState = {
  user: null,
  skillId: '',
  kind: '',
  windowHours: 48,
  includeExpired: false,
};
